import { createVuetify } from 'vuetify'
import * as components from 'vuetify/lib/components'
import * as directives from 'vuetify/lib/directives'
import { ar } from 'vuetify/locale'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

const vuetify = createVuetify({
  components,
  directives,
  defaults: {
    global: {
      elevation: 0
    },
    VBtn: {
      rounded: 'lg'
    },
    VCard: {
      rounded: 'xl',
      elevation: 0
    },
    VTextField: {
      variant: 'outlined'
    },
    VSelect: {
      variant: 'outlined'
    },
    VTextarea: {
      variant: 'outlined'
    },
  },
  locale: {
    locale: 'ar',
    fallback: 'ar',
    messages: { ar },
    rtl: {
      ar: true
    }
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#0071e3',
          secondary: '#86868b',
          surface: '#ffffff',
          background: '#f5f5f7',
          success: '#34c759',
          warning: '#ff9500',
          error: '#ff3b30',
          info: '#0071e3'
        }
      }
    }
  }
})

export default vuetify
